import { Chart} from 'chart.js';

import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['chart'];

  connect() {
    this.chartTargets.forEach((chart) => {
      var datasets = [];
      var children = Array.from(chart.children);
      if(chart.dataset.multiple == 'true'){
        children.forEach(function(c, i){
          datasets.push({
            label: c.dataset.name,
            yAxisID: ('y_'+i),
            fill: (c.dataset.fill == 'true'),
            data: c.dataset.array.split(','),
            borderColor: c.dataset.color,
            backgroundColor: c.dataset.color
          })
        })
      } else {
        datasets.push({
          label: chart.dataset.name,
          fill: (chart.dataset.fill == 'true'),
          data: chart.dataset.array.split(','),
          borderColor: chart.dataset.color,
          backgroundColor: chart.dataset.color
        })
      };

      if(chart.id == 'shared--chart__click-user-chart'){
        this.click_user_chart(chart, datasets);
      } else {
        this.show_chart(chart, datasets);
      }
    })
  }

  show_chart(chart, data) {
    new Chart(chart, {
      type: 'line',
      data: {
        labels: chart.dataset.labels.split(','),
        datasets: data
      }
    });
  }

  click_user_chart(chart, data) {
    new Chart(chart, {
      type: 'line',
      data: {
        labels: chart.dataset.labels.split(','),
        datasets: data
      },
      options: {
        scales: {
          yAxes: [{
            id: 'y_0',
            type: 'linear',
            position: 'left',
            ticks: {
              max: parseInt(chart.dataset.lmax),
              min: 0
            }
          }, {
            id: 'y_1',
            type: 'linear',
            position: 'right',
            ticks: {
              max: parseInt(chart.dataset.rmax),
              min: 0
            }
          }]
        }
      }
    });
  }
}
